import { HomeFocusSelection, HomeStore } from '../stores/HomeStore';
import { NotebookList } from './NotebookList';
import { TinkerBoxConnect } from './TinkerBoxConnect';

interface NotebookOrShellProps {
  store: HomeStore;
  // webSocketClient: WebSocketClient;
}

export const NotebookOrShell = ({
  store
}: // webSocketClient
NotebookOrShellProps) => {
  console.log(store.selectedMode);
  return (
    <>
      <TinkerBoxConnect
        tinkerBoxConnection={store.tinkerBoxConnection}
        focus={store.focus === HomeFocusSelection.terminal}
        className={`${
          store.selectedMode === 'terminal' ? 'visible flex-grow' : 'hidden'
        }`}
      />
      <NotebookList
        store={store}
        // webSocketClient={webSocketClient}
        className={`${
          store.selectedMode === 'notebook' ? 'visible flex-grow' : 'hidden'
        }`}
      />
    </>
  );
};
